// アプリユーザAPI.
import axios, { AxiosInstance } from 'axios';
import { Dispatch } from 'redux';
import * as Moff from '../constants/MoffAPI';
import * as AppUser from '../constants/AppUser';
import * as AWS from '../constants/AWS';
// import { INTEREST_CHECK_ERR_MSG } from '../constants/InterestCheck';
import { SERVICE_ERR_MSG } from '../constants/HomeVisit';
import { InterestCheckAPI } from '../api/InterestCheckAPI';

export class AppUserAPI {
  /** インスタンス */
  private static _instance: AppUserAPI;
  private axiosInstance: AxiosInstance;

  /** インスタンスの取得 */
  public static get instance(): AppUserAPI | null {
    // _inctanceが存在しない場合に、new User()を実行する。
    if (!this._instance) {
      this._instance = new AppUserAPI();

      // .envの設定 
      const API_BASE_URL = String(process.env.REACT_APP_APP_USER_API_URL);
      const API_KEY = String(process.env.REACT_APP_APP_USER_API_KEY);
      if (typeof API_BASE_URL === 'undefined') {
        alert('.envにREACT_APP_APP_USER_API_URLの設定がありません.');
        return null;
      }

      if (typeof API_KEY === 'undefined') {
        alert('.envにREACT_APP_APP_USER_API_KEYの設定がありません.');
        return null;
      }

      const userPool = AWS.userPool();
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser === null) {
        return null;
      }

      const self = this;
      cognitoUser.getSession(function(err: any, session: any) {
        if (err) {
          return;
        }

        if (session) {
          self._instance.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            headers: {
              'Authorization': session.getIdToken().getJwtToken(),
              'x-api-key': API_KEY
            }
          });
        }
      });
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  /**
   *  興味関心チェックまたは居宅訪問の登録がユーザがあるか確認.
   *
   * @param {string} userId
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof AppUserAPI
   */
  public getAppUser(
    userId: string, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `/app/${Moff.LOCOMO_TYPE}/user/${userId}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(AppUser.SUCCESS, response));
        })
        .catch(function(error: any) {
          self.showAxiosError('getAppUser', error);
          dispatch(fetchedFunc(AppUser.ERROR, error));
        });
    };
  }

  /**
   * 興味関心チェックまたは居宅訪問の登録がユーザがあるか確認.
   * あれば件数を取り、最後の件数のシーケンスで日付取得.
   *
   * @param {string} userId
   * @param {HTMLElement[]} elements
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof AppUserAPI
   */
  public getInterestCheckLastDate(
    userId: string, elements: HTMLElement[], requestFunc: Function, fetchedFunc: Function): any {
    const url = `/app/${Moff.LOCOMO_TYPE}/user/${userId}`;
    const interestCheck = InterestCheckAPI.instance;
    return (dispatch: Dispatch<any>) => {
      // ここで同時にカウントリセット.
      dispatch(requestFunc());

      this.axiosInstance.get(url)
        .then(function(response: any) {
          if (interestCheck != null) {
            if (response.data) {
              // 件数を取り、最後のシーケンスで日付取得.
              dispatch(
                interestCheck.getLastDate(userId, response.data.unique_id, elements, requestFunc, fetchedFunc)
              );
            } else {
              // なし.
              elements[userId].innerText = '';
              return;
            }
          }
        })
        .catch(function(error: any) {
          elements[userId].innerText = '';
        });
    };
  }

  // エラーポップアップ.
  // apiNameはどのAPIによるものか.
  private showAxiosError(apiName: string, error: any) {
    // ユーザがいないときは404.
    if (error.toString().indexOf('404') > -1) {
      alert(SERVICE_ERR_MSG);
      return;
    }

    if (error.toString().indexOf('Network Error') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が出来ることを確認してから再度ページを読み込み直して下さい。';
      alert(errorMessage);
    } else if (error.toString().indexOf('timeout') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が良好な環境で、再度ページを読み込み直して下さい。';
      alert(errorMessage);
    }

    // ログインへ.
    window.location.href = '/';
  }
}



// WEBPACK FOOTER //
// ./src/api/AppUser.tsx